module.exports = __webpack_public_path__ + "img/munchybit-logo.a5f88826.png";